<template>
  <div class="actor">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Actor'
}
</script>
